import { FallBackImage, useAppPersistenceStore, useProfileStore } from '@ninjacart/nc-nk-store';
import { Card, Image, Text, View, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { RefreshCcw, X } from '@tamagui/lucide-icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, Easing } from 'react-native';
import { useResumableQnaStore } from '../../store/useResumableQnaStore';
import { useFeatureFlag } from '@ninjacart/nc-nk-ff4j';

const RenderProgressBar = () => {
  const progresBarConfig = useResumableQnaStore((state) => state.progresBarConfig);
  const setProgresBarConfig = useResumableQnaStore((state) => state.setProgresBarConfig);
  const [showProgressBar, setShowProgressBar] = useState(true);
  const animation = useRef(new Animated.Value(0)).current;
  const { push, back } = useRouter();
  const userProfile = useProfileStore((state) => state.userProfile);
  const { t } = useTranslation();
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const requestQnAFeatureFlow = useFeatureFlag(
    'requestQnAFeatureFlow',
    'UserDeviceId',
    uniqueDeviceId!
  );

  const [qnaNewFlow] = useState(requestQnAFeatureFlow ? '/askQuestionSearch' : '/qna/create');

  const stopBackgroundUplode = () => {
    setShowProgressBar(false);
    setProgresBarConfig({
      ...progresBarConfig,
      isError: false,
      progressPercentage: 1,
      inProgress: false,
    });
  };

  const retryUpload = () => {
    push(qnaNewFlow);
  };

  useEffect(() => {
    // Start indeterminate animation
    Animated.loop(
      Animated.timing(animation, {
        toValue: 1,
        duration: 2000,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    ).start();
  }, [animation]);

  if ((progresBarConfig?.inProgress || progresBarConfig.isError) && showProgressBar) {
    return (
      <Card
        width={'100%'}
        shadowColor={'#000000'}
        shadowRadius={5}
        elevation={5}
        margin={5}
        shadowOpacity={0.2}
        marginVertical={10}
        backgroundColor={'$ctaBgColor'}
        borderColor={'$ctaBorderColor'}
        paddingLeft={15}
        paddingBottom={15}
        paddingTop={0}
        paddingRight={15}
      >
        <YStack height={72}>
          <XStack alignItems="center" gap={5} height={'95%'}>
            <Image
              source={{
                uri: userProfile?.user?.['mediaDetails']?.media?.[0]?.mediaUrl ?? FallBackImage,
              }}
              width={40}
              height={40}
              borderRadius={4}
            />
            <View style={{ width: '80%' }}>
              <XStack alignItems="center" justifyContent={'space-between'} marginRight={15}>
                {progresBarConfig.isError ? (
                  <Text
                    style={{
                      color: '#585858',
                      fontSize: 14,
                      fontWeight: '400',
                      paddingRight: 20,
                    }}
                  >
                    {t('page.somethingWentWrongPleaseTryAgainLater')} ...
                  </Text>
                ) : (
                  <Text style={{ color: '#368665', fontSize: 13, fontWeight: '400' }}>
                    {t('page.weArePostingYourVideo')} ...
                  </Text>
                )}
                {progresBarConfig.isError && (
                  <XStack>
                    <RefreshCcw onPress={retryUpload} size={20} marginRight={5} />
                    <X onPress={stopBackgroundUplode} size={20} marginLeft={2} />
                  </XStack>
                )}
              </XStack>
            </View>
          </XStack>
          <View
            style={{
              backgroundColor: progresBarConfig.isError ? '#FF0E0E' : '#CBE7DB',
              height: 3.9,
              display: 'flex',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {Math.ceil(progresBarConfig.progressPercentage) < 100 ? (
              <View
                style={{
                  backgroundColor: progresBarConfig.isError ? '#FF0E0E' : '#368665',
                  height: 4,
                  width: `${Math.ceil(progresBarConfig.progressPercentage)}%`,
                  left: '0%',
                  position: 'relative',
                }}
              ></View>
            ) : (
              <Animated.View
                style={{
                  backgroundColor: 'green',
                  height: 4,
                  width: '100%',
                  transform: [
                    {
                      translateX: animation.interpolate({
                        inputRange: [0, 1],
                        outputRange: [-150, 150],
                      }),
                    },
                  ],
                }}
              />
            )}
          </View>
        </YStack>
      </Card>
    );
  }

  return null;
};

export default RenderProgressBar;
